import {DashboardTileId} from '../types/DashboardTileId';

// Retired composite tiles and the tiles that replaced them, left to right. Only legacy (two-column)
// arrangements can still carry the retired ids. A Map, for the same reason as the id aliases.
export const DASHBOARD_TILE_ID_SPLITS = new Map<
  string,
  readonly [DashboardTileId, DashboardTileId]
>([['notifications-and-tasks', ['my-tasks', 'notifications']]]);
